import script from "./review.vue?vue&type=script&setup=true&lang=js"
export * from "./review.vue?vue&type=script&setup=true&lang=js"

import "./review.vue?vue&type=style&index=0&id=32e23f7c&lang=css"

const __exports__ = script;

export default __exports__